// src/components/exam-player/renderers/MatchingRenderer.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

function shuffleArray(arr) {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  console.log("Shuffled Array:", copy); // اضافه کردن لاگ
  return copy;
}

export default function MatchingRenderer({
  item,
  onAnswerChange,
  initialAnswers,
  questionNumber,
}) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language?.includes("fa");

  const pairs = Array.isArray(item?.body?.pairs) ? item.body.pairs : [];
  const layout = item?.body?.layout || "left-right";

  const leftFirst =
    layout === "left-right" || layout === "bottom-top" ? true : false;
  const isVertical = layout === "bottom-top";

  // --- آماده‌سازی لیست چپ و راست ---
  const leftItems = useMemo(
    () =>
      pairs.map((p, idx) => ({
        idx,
        label:
          p?.left?.fa ||
          p?.left?.en ||
          t("matching.left_default", { n: idx + 1 }),
      })),
    [pairs, t]
  );

  const rightItems = useMemo(
    () =>
      pairs.map((p, idx) => ({
        idx,
        label:
          p?.right?.fa ||
          p?.right?.en ||
          t("matching.right_default", { n: idx + 1 }),
      })),
    [pairs, t]
  );

  // ستون راست شافل می‌شود ولی idx اصلی را نگه می‌داریم
  const shuffledRights = useMemo(() => shuffleArray(rightItems), [rightItems]);

  // --- مقدار اولیه از initialAnswers ---
  const initialMap = useMemo(() => {
    if (!initialAnswers || typeof initialAnswers !== "object") return {};
    if (initialAnswers.matches && typeof initialAnswers.matches === "object") {
      return { ...initialAnswers.matches };
    }
    return { ...initialAnswers };
  }, [initialAnswers]);

  const [matches, setMatches] = useState(initialMap);

  console.log(rightItems)

  useEffect(() => {
    setMatches(initialMap);
  }, [initialMap]);

  const handleSelect = (leftIdxStr, rightIdxStr) => {
    const next = {
      ...matches,
      [leftIdxStr]: rightIdxStr || undefined,
    };
    setMatches(next);
    // می‌فرستیم همون map را به عنوان value
    onAnswerChange?.(next);
  };

  if (!pairs.length) {
    return (
      <div className="text-sm text-red-600">
        {t("preview.kind_not_supported", { kind: "matching" })}
      </div>
    );
  }

  const containerClass = isVertical
    ? "flex flex-col gap-3"
    : "grid grid-cols-1 md:grid-cols-2 gap-4";

  return (
    <div dir={isRtl ? "rtl" : "ltr"}>
      {/* Stem */}
      <div className="prose prose-sm max-w-none mb-4">
        <div
          dangerouslySetInnerHTML={{
            __html:
              item?.stem?.fa ||
              item?.stem?.en ||
              t("preview.no_stem", "بدون متن"),
          }}
        />
        {/* {typeof questionNumber === "number" && (
          <div className="text-xs text-gray-500 mt-1">
            {t("preview.question_number", { n: questionNumber })}
          </div>
        )} */}
      </div>

      {/* Matching content */}
      <div className={containerClass}>
        {leftFirst ? (
          <>
            {/* ستون چپ (ثابت) */}
            <div className="space-y-2">
              <div className="text-xs font-semibold text-gray-500">
                {t("matching.left_col")}
              </div>
              {leftItems.map((it) => (
                <div
                  key={it.idx}
                  className="border rounded-lg px-3 py-2 bg-white text-sm"
                >
                  {it.label}
                </div>
              ))}
            </div>

            {/* ستون انتخابی راست */}
            <div className="space-y-2">
              <div className="text-xs font-semibold text-gray-500">
                {t("matching.right_col")}
              </div>
              {leftItems.map((it) => {
                const leftKey = String(it.idx);
                const value = matches[leftKey] ?? "";
                return (
                  <select
                    key={it.idx}
                    className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
                    value={value}
                    onChange={(e) =>
                      handleSelect(leftKey, e.target.value || "")
                    }
                  >
                    <option value="">
                      {t("matching.select_placeholder", "انتخاب کنید")}
                    </option>
                    {shuffledRights.map((r) => (
                      <option key={r.idx} value={String(r.idx)}>
                        {r.label}
                      </option>
                    ))}
                  </select>
                );
              })}
            </div>
          </>
        ) : (
          // حالت right-left (فقط جا عوض می شود)
          <>
            {/* ستون انتخابی (راست) */}
            <div className="space-y-2">
              <div className="text-xs font-semibold text-gray-500">
                {t("matching.right_col")}
              </div>
              {leftItems.map((it) => {
                const leftKey = String(it.idx);
                const value = matches[leftKey] ?? "";
                return (
                  <select
                    key={it.idx}
                    className="w-full border rounded-lg px-3 py-2 text-sm bg-white"
                    value={value}
                    onChange={(e) =>
                      handleSelect(leftKey, e.target.value || "")
                    }
                  >
                    <option value="">
                      {t("matching.select_placeholder", "انتخاب کنید")}
                    </option>
                    {shuffledRights.map((r) => (
                      <option key={r.idx} value={String(r.idx)}>
                        {r.label}
                      </option>
                    ))}
                  </select>
                );
              })}
            </div>

            {/* ستون چپ (ثابت) */}
            <div className="space-y-2">
              <div className="text-xs font-semibold text-gray-500">
                {t("matching.left_col")}
              </div>
              {leftItems.map((it) => (
                <div
                  key={it.idx}
                  className="border rounded-lg px-3 py-2 bg-white text-sm"
                >
                  {it.label}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
